import { render } from "./SideBar.vue?vue&type=template&id=169de34a"
import script from "./SideBar.vue?vue&type=script&lang=ts"
export * from "./SideBar.vue?vue&type=script&lang=ts"
script.render = render

export default script